import React, { useContext, useEffect, useRef, useState } from 'react'
import TopBar from '../Layouts/TopBar'
import Sidebar from '../Layouts/Sidebar'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min'
import instance from '../Config/AxiosConfig'
import Cookies from 'js-cookie';
import { useDelete } from '../Context/ApiContext'
import { AuthContext } from '../Context/AuthProvider'
import Lottie from 'react-lottie'
import animationData from '../lotties/CommunityNotfound.json';
import Swal from 'sweetalert2'
function CommunityDetails() {

    const { id } = useParams()
    const { user } = useContext(AuthContext)
    const [communities, setCommunities] = useState([]);
    const { handleJoin, join } = useDelete();

    useEffect(() => {
        const token = Cookies.get('token');
        instance.get(`/communities/get/${id}`, token)
            .then(response => {

                setCommunities(response.data);
            })

            .catch(error => {
                console.error('Erreur lors de la récupération des données:', error);
            });

    }, [join]);

    //pour verifier user connecte est un membre de la community
    const userxx = communities.members?.map(prevuser => prevuser.id)
    console.log(userxx, 'userxxuserxxuserxx');
    const communitiesUser = userxx?.includes(user.id)
    const commwidthoutuser = communities.members?.filter(prevuser => prevuser.id !== user.id)
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    const [invite, setInvite] = useState('')


    const handleInvit = async (id, e) => {


        const token = Cookies.get('token');
        // e.preventDefault();
        e.currentTarget.style.display = 'none';
        console.log(e)

        let data = new FormData();
        data.append('id', id);
        data.append('message', 'message');
        try {

            const response = await instance.post('/connectionRequests/send', data, token)
            if (response.status === 200) {
                Swal.fire({
                    position: "top-center",
                    icon: "success",
                    title: "Connection request sent successfully.",
                    showConfirmButton: false,
                    timer: 1500,
                    imageWidth: 200,
                    imageHeight: 200,
                });

                setInvite(response.data)

            } else {
                alert("error")

            }

        }
        catch (error) {
            console.error('Erreur lors de la récupération des données:', error);
        }

    }

    return (
        <>
            <TopBar />
            <main>
                <div className="container">
                    <div className="row g-4">
                        <div className="col-lg-3">
                            <Sidebar />
                        </div>

                        <div className="col-md-8 col-lg-9 vstack gap-4">
                            <div className="card ">
                                {/* Card body START */}
                                {communities &&
                                    <div className="card-body">

                                        <div className="d-md-flex flex-wrap align-items-start text-center text-md-start">
                                            <div className="mb-2">
                                                {/* Avatar */}
                                                <div className="avatar avatar-xl">
                                                    <img className="avatar-img border-0" src={communities.image} alt="" />
                                                </div>
                                            </div>
                                            <div className="ms-md-4 mt-3">
                                                <h1 className="h5 mb-0">{communities.name} <i className="bi bi-patch-check-fill text-success small" /></h1>
                                                <ul className="nav nav-divider justify-content-center justify-content-md-start">
                                                    <li className="nav-item"> Private group </li>
                                                    <li className="nav-item"> {communities.members?.length} members </li>
                                                </ul>
                                            </div>
                                            {/* Button */}
                                            {

                                                <div className="d-flex justify-content-center justify-content-md-start align-items-center mt-3 ms-lg-auto">
                                                    {
                                                        !communitiesUser && !communitiesUser ?

                                                            <button onClick={() => handleJoin(communities.id)} className="btn btn-sm btn-primary-soft me-2 Invite" type="button"> <i className="bi bi-person-check-fill pe-1" /> Join</button>
                                                            :
                                                            <button className="btn btn-sm btn-success-soft buttonInvite me-2" >
                                                                <span className="span"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 23 21" height={21} width={23} className="svg-iconInvite">
                                                                    <path strokeLinejoin="round" strokeLinecap="round" strokeWidth={2} stroke="black" d="M1.97742 19.7776C4.45061 17.1544 7.80838 15.5423 11.5068 15.5423C15.2053 15.5423 18.5631 17.1544 21.0362 19.7776M16.2715 6.54229C16.2715 9.17377 14.1383 11.307 11.5068 11.307C8.87535 11.307 6.74212 9.17377 6.74212 6.54229C6.74212 3.91082 8.87535 1.77759 11.5068 1.77759C14.1383 1.77759 16.2715 3.91082 16.2715 6.54229Z" />
                                                                </svg></span>
                                                                <span className="lableInvite">Invite</span>
                                                            </button>

                                                    }
                                                </div>
                                            }
                                        </div>

                                        <ul className="avatar-group list-unstyled justify-content-center justify-content-md-start align-items-center mb-0 mt-3 flex-wrap">
                                            {communities.members?.slice(0, 5).map((member, index) => (
                                                <li key={index} className="avatar avatar-xs">
                                                    <img
                                                        className={`avatar-img rounded-circle ${!communitiesUser ? 'opacity-25' : ''}`}

                                                        src={member.profilePicture}
                                                        alt="avatar"
                                                    />
                                                </li>
                                            ))}
                                            {communities.members?.length > 5 && (
                                                <li className="avatar avatar-xs" style={{ cursor: "pointer" }}>
                                                    <div className="avatar-img rounded-circle bg-primary">
                                                        <span className="smaller text-white position-absolute top-50 start-50 translate-middle">+{communities.members?.length - 5}</span>
                                                    </div>
                                                </li>
                                            )}
                                        </ul>
                                        {/* Join group END */}
                                    </div>
                                }{/* Card body END */}

                            </div>
                            <div className="card ">
                                {/* Card body START */}
                                {communities &&
                                    <div className="card-body">

                                        <ul className="list-unstyled">
                                            {
                                                communitiesUser ?

                                                    <>
                                                        {commwidthoutuser?.map((member, index) => (


                                                            <div className="d-md-flex align-items-center mb-4" key={index}>
                                                                {/* Avatar */}
                                                                <div className="avatar me-3 mb-3 mb-md-0">
                                                                    <a href="#!"> <img className="avatar-img rounded-circle" src={member.profilePicture} alt='' /> </a>
                                                                </div>
                                                                {/* Info */}
                                                                <div className="w-100">
                                                                    <div className="d-sm-flex align-items-start">

                                                                        <h6 className="mb-0"><a href={"/profil/" + member.id}>{member.firstName} </a></h6>


                                                                        <p className="small ms-sm-2 mb-0"><a href={member.link} style={{ color: 'rgb(103, 106, 121' }}>{member.link}</a></p>
                                                                    </div>
                                                                </div>
                                                                {/* Button */}
                                                                <div className="ms-md-auto d-flex">

                                                                    <button className="btn btn-success-soft btn-sm mb-0 me-2" onClick={(e) => handleInvit(member.id, e)} > Invite </button>
                                                                    <button className='Commutybutton'>
                                                                        <div className="Commutysvg-wrapper-1">
                                                                            <div className="Commutysvg-wrapper">
                                                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24}>
                                                                                    <path fill="none" d="M0 0h24v24H0z" />
                                                                                    <path fill="currentColor" d="M1.946 9.315c-.522-.174-.527-.455.01-.634l19.087-6.362c.529-.176.832.12.684.638l-5.454 19.086c-.15.529-.455.547-.679.045L12 14l6-8-8 6-8.054-2.685z" />
                                                                                </svg>
                                                                            </div>
                                                                        </div>
                                                                        <span>message</span>
                                                                    </button>

                                                                </div>
                                                            </div>

                                                        ))}
                                                    </> :
                                                    <>
                                                        <h5 className='text-danger bold text-center mt-5'> No Community details please join community for more details ...</h5>
                                                        <Lottie
                                                            options={defaultOptions}
                                                            height={300}
                                                            width={300}
                                                        />
                                                    </>
                                            }
                                        </ul>
                                    </div>

                                }{/* Card body END */}

                            </div>
                        </div>
                    </div>
                </div>




            </main >


        </>
    )
}

export default CommunityDetails